import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ChangePwdModalAnt from './ChangePwdModalAnt.js'
import { NavLink } from 'react-router-dom';

class TopBar extends Component {

    render() {
        const { t, showMenu, displayName, toggle, logout } = this.props;
        let loginName = sessionStorage.getItem('username');
        if (loginName) {
            loginName = loginName.substring(0, loginName.indexOf("@"));
        }
        const isLocalUser = sessionStorage.getItem('isLocalUser') === 'true';

        return (
            <div className="brand clearfix">
                <li title={showMenu ? "Hide Menu" : "Show Menu"} className="left-menu-toggle">
                    <NavLink to="#" onClick={toggle}>
                        <i className="pholio-left-menu-icon"
                           style={{"textAlign": "center","paddingTop": "5px"}}></i>
                    </NavLink>
                </li>
                <a href="/main/dashboard" className="logo"><img src="/img/logo.png" className="img-responsive" alt="" /></a>
                <div className="product-name">Cloud Service Administration</div>
                <ul className="ts-profile-nav">
                    <li className="ts-account" style={{textAlign:'center'}}>
                        <a href="#" style={{textDecoration:'none'}}>
                            <span className="top-icon top-icon-avatar"/>
                            {displayName ? displayName : loginName}
                            <i className="fa fa-angle-down hidden-side"/>
                        </a>
                        <ul style={{textAlign: 'left'}}>
                            {isLocalUser && <li><ChangePwdModalAnt/></li>}
                            <li><a href="#" onClick={logout}>{t("USER.LOGOUT")}</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}

export default translate()(TopBar);


// WEBPACK FOOTER //
// ./src/modules/main/TopBar.js